import React, {Component} from "react";
import CookieConsent, {Cookies} from "react-cookie-consent";

class CookieConsentModilect extends Component {
  render() {
    return (
      <CookieConsent
        style={{
        background: 'rgba(0,0,0,0.8)',
        flexDirection: "column",
        minHeight: '100vh',
        alignItems: "center",
        padding: '0 40px',
        boxSizing: 'border-box',
        justifyContent: 'center'
      }}
        buttonStyle={{
        background: "none",
        border: "1px solid white",
        color: "white",
        fontWeight: '400',
        width: '100%',
        maxWidth: 250,
        height: '85px',
        cursor: 'pointer',
        textTransform: 'uppercase'
      }}
        contentStyle={{
        height: 'auto',
        flex: ' 0 0 auto',
        textAlign: 'center'
      }}
        buttonText={'Jag Förstår'}>
        <div>

          Vi använder cookies för att ge dig en bättre upplevelse av Modilect.se.{" "}
          <a target="_blank" href={'./cookies'}>
            Läs mer här.</a>
          <div></div>
        </div>
      </CookieConsent>
    );
  }
}

export default CookieConsentModilect;



// WEBPACK FOOTER //
// ./src/Global/CookieConsentModilect.js